import React, { useState } from 'react';
import '../Certifications.css';
import agentforceImage from '../img/certifications/AGENTFORCEAI-SALESFORCE.jpg'; // Changed to image
import aiAssociateImage from '../img/certifications/AIAssociate-salesforce.jpg'; // Changed to image
import aiTheoryHelsinkyCertificate from '../img/certifications/AITheoryHelsinkyCertificate.jpg';
import baiAdvancedCertificate from '../img/certifications/certificate-bai-advanced.jpg';
import data360ConsultantImage from '../img/certifications/Data360Consultant-salesforce.jpg';
import javaFxCertificate from '../img/certifications/JavaFX.jpg';
import platformDeveloperImage from '../img/certifications/PlataformDeveloper.jpg'; // Import the new certificate image
import appBuilderCertificate from '../img/certifications/appbuilder-certified.jpeg';

function Certifications({ id }) {
  const [showAgentforceImage, setShowAgentforceImage] = useState(false); // Changed to image
  const [showAiAssociateImage, setShowAiAssociateImage] = useState(false); // Changed to image
  const [showAiTheoryHelsinkyImage, setShowAiTheoryHelsinkyImage] = useState(false);
  const [showBaiAdvancedImage, setShowBaiAdvancedImage] = useState(false);
  const [showData360ConsultantImage, setShowData360ConsultantImage] = useState(false);
  const [showJavaFxImage, setShowJavaFxImage] = useState(false);
  const [showPlatformDeveloperImage, setShowPlatformDeveloperImage] = useState(false); // New state for Platform Developer
  const [showAppBuilderImage, setShowAppBuilderImage] = useState(false);

  const handleAgentforceClick = () => {
    setShowAgentforceImage(true); // Changed to image
  };

  const handleAiAssociateClick = () => {
    setShowAiAssociateImage(true); // Changed to image
  };

  const handleAiTheoryHelsinkyClick = () => {
    setShowAiTheoryHelsinkyImage(true);
  };

  const handleBaiAdvancedClick = () => {
    setShowBaiAdvancedImage(true);
  };

  const handleData360ConsultantClick = () => {
    setShowData360ConsultantImage(true);
  };

  const handleJavaFxClick = () => {
    setShowJavaFxImage(true);
  };

  const handlePlatformDeveloperClick = () => {
    setShowPlatformDeveloperImage(true); // New handler for Platform Developer
  };

  const handleAppBuilderClick = () => {
    setShowAppBuilderImage(true);
  };

  const handleClosePdf = () => {
    setShowAgentforceImage(false); // Changed to image
    setShowAiAssociateImage(false); // Changed to image
    setShowAiTheoryHelsinkyImage(false);
    setShowBaiAdvancedImage(false);
    setShowData360ConsultantImage(false);
    setShowJavaFxImage(false);
    setShowPlatformDeveloperImage(false); // Close the Platform Developer modal
    setShowAppBuilderImage(false);
  };

  return (
    <section id={id}>
      <h2>Certifications</h2>
      <div className="certification-item" onClick={handlePlatformDeveloperClick}>
        <h3>Platform Developer</h3>
        <p className="salesforce-background">Salesforce</p>
      </div>
      {showPlatformDeveloperImage && ( // New modal for Platform Developer
        <div className="pdf-modal" onClick={handleClosePdf}>
          <div className="pdf-content image-content">
            <img src={platformDeveloperImage} alt="Platform Developer Certification" />
            <button onClick={handleClosePdf}>Close</button>
          </div>
        </div>
      )}
      <div className="certification-item" onClick={handleAppBuilderClick}>
        <h3>Platform App Builder</h3>
        <p className="salesforce-background">Salesforce</p>
      </div>
      {showAppBuilderImage && (
        <div className="pdf-modal" onClick={handleClosePdf}>
          <div className="pdf-content image-content">
            <img src={appBuilderCertificate} alt="Platform App Builder Certification" />
            <button onClick={handleClosePdf}>Close</button>
          </div>
        </div>
      )}
      <div className="certification-item" onClick={handleData360ConsultantClick}>
        <h3>Data 360 Consultant</h3>
        <p className="salesforce-background">Salesforce</p>
      </div>
      {showData360ConsultantImage && (
        <div className="pdf-modal" onClick={handleClosePdf}>
          <div className="pdf-content image-content">
            <img src={data360ConsultantImage} alt="Data 360 Consultant Certification" />
            <button onClick={handleClosePdf}>Close</button>
          </div>
        </div>
      )}
      <div className="certification-item" onClick={handleAgentforceClick}>
        <h3>Agentforce Specialist</h3>
        <p className="salesforce-background">Salesforce</p>
      </div>
      {showAgentforceImage && ( // Changed to image
        <div className="pdf-modal" onClick={handleClosePdf}>
          <div className="pdf-content image-content"> {/* Reusing image-content */}
            <img src={agentforceImage} alt="Agentforce Specialist Certification" /> {/* Changed to image */}
            <button onClick={handleClosePdf}>Close</button>
          </div>
        </div>
      )}
      <div className="certification-item" onClick={handleAiAssociateClick}>
        <h3>AI Associate</h3>
        <p className="salesforce-background">Salesforce</p>
      </div>
      {showAiAssociateImage && ( // Changed to image
        <div className="pdf-modal" onClick={handleClosePdf}>
          <div className="pdf-content image-content"> {/* Reusing image-content */}
            <img src={aiAssociateImage} alt="AI Associate Certification" /> {/* Changed to image */}
            <button onClick={handleClosePdf}>Close</button>
          </div>
        </div>
      )}
      <div className="certification-item" onClick={handleAiTheoryHelsinkyClick}>
        <h3>Introduction to AI of Elements of AI</h3>
        <p className="helsinki-background">University of Helsinki and MinnaLearn</p>
      </div>
      {showAiTheoryHelsinkyImage && (
        <div className="pdf-modal" onClick={handleClosePdf}>
          <div className="pdf-content image-content">
            <img src={aiTheoryHelsinkyCertificate} alt="Introduction to AI Certificate" />
            <button onClick={handleClosePdf}>Close</button>
          </div>
        </div>
      )}
      <div className="certification-item" onClick={handleBaiAdvancedClick}>
        <h3>Building AI of Elements of AI</h3>
        <p className="helsinki-background">University of Helsinki and MinnaLearn</p>
      </div>
      {showBaiAdvancedImage && (
        <div className="pdf-modal" onClick={handleClosePdf}>
          <div className="pdf-content image-content">
            <img src={baiAdvancedCertificate} alt="Building AI Certificate" />
            <button onClick={handleClosePdf}>Close</button>
          </div>
        </div>
      )}
      <div className="certification-item" onClick={handleJavaFxClick}>
        <h3>JAVA FX application development</h3>
        <p className="altia-background">Altia S.A.</p>
      </div>
      {showJavaFxImage && (
        <div className="pdf-modal" onClick={handleClosePdf}>
          <div className="pdf-content image-content">
            <img src={javaFxCertificate} alt="JavaFX Certificate" />
            <button onClick={handleClosePdf}>Close</button>
          </div>
        </div>
      )}
      <div className="certification-item">
        <h3>SWT application development</h3>
        <p className="altia-background">Altia S.A.</p>
      </div>
    </section>
  );
}

export default Certifications;
